import { ImageModel } from "./ImageModel";
export default ImageModel;
